module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0014.59e6a144.jpg";